module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN207_1567573579.32115611.png";